<template>
    <v-app id="psi">
        <auth-layout v-if="initialized"></auth-layout>
        <psi-app-loader v-else></psi-app-loader>
    </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    name: "App",
    components: {
        AuthLayout: () => import("./layouts/auth/AuthLayout"),
    },
    data: () => ({}),
    computed: {
        ...mapGetters(["initialized"]),
    },
    methods: {
        ...mapActions("User", ["getUser"]),
    },
};
</script>

<style>
</style>

